module.exports = __webpack_public_path__ + "img/coach-slide3.48d4e157.png";